import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldOff, ArrowLeft, Home } from "lucide-react";

export default function NoAccess({ module = "" }) {
  const navigate = useNavigate();
  const moduleLabel = module
    ? module.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())
    : "this page";

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-8">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-[#FBEAE7] rounded-full flex items-center justify-center mx-auto mb-6">
          <ShieldOff size={36} className="text-[#C2624E]" />
        </div>
        <h1 className="text-2xl font-extrabold font-[Manrope] text-[#3A322C] mb-2">
          Access Restricted
        </h1>
        <p className="text-[#8A7E73] mb-1">
          You don't have permission to access{" "}
          <span className="font-bold text-[#5C5147]">{moduleLabel}</span>.
        </p>
        <p className="text-sm text-[#C4BAAF] mb-8">
          Contact your administrator to request access to this module.
        </p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 border border-[#E5E1DB] rounded-lg px-4 py-2.5 text-sm font-bold text-[#5C5147] hover:bg-[#F4F3F0] transition-colors"
          >
            <ArrowLeft size={15} /> Go Back
          </button>
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 bg-[#E8956D] text-[#3A322C] rounded-lg px-4 py-2.5 text-sm font-bold hover:bg-[#D48661] transition-colors"
          >
            <Home size={15} /> Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
